<script>
export default {
    props: {
        isChild: {
            type: [Boolean, Number],
            default: false
        }
    }
};
</script>

<template>
    <span v-if="isChild" class="badge badge-soft-success font-size-11">
        Sí
    </span>
    <span v-else class="badge badge-soft-danger font-size-11">
        No
    </span>
</template> 